import { render, staticRenderFns } from "./NavBarTopAdmin.vue?vue&type=template&id=32bd1fb0&scoped=true&"
import script from "./NavBarTopAdmin.vue?vue&type=script&lang=js&"
export * from "./NavBarTopAdmin.vue?vue&type=script&lang=js&"
import style0 from "./NavBarTopAdmin.vue?vue&type=style&index=0&id=32bd1fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bd1fb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBarNavIcon,VBtn,VIcon,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
